class ProductHero extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.isTicking = false

    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    this.setAttribute('active', '')
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll, {
      passive: true,
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.toggleOnScreen()
    this.toggleScrolledPast()

    if (this.dataset.type === 'slide_details') {
      this.toggleExtraContent()
    }

    if (this.dataset.type === 'slide_chart') {
      this.toggleExtraChartContent()
    }
  }

  toggleOnScreen () {
    const elementTop = window.BAO.Utils.getOffsetTop(this)
    const elementHeight = this.offsetHeight
    const viewportHeight = window.innerHeight

    // Calculate the point at which 25% of the element is visible
    const visibilityThreshold = elementTop + elementHeight * 0.25

    // Calculate the point at which the element is fully visible on the screen
    const elementVisible = elementTop + elementHeight

    // Determine if the element has the 'data-last' attribute
    const hasDataLast = this.hasAttribute('data-last')

    // Handle special case for elements with 'data-last'
    const isVisible = hasDataLast
      ? this.lastKnownY + viewportHeight >= visibilityThreshold
      : this.lastKnownY + viewportHeight >= visibilityThreshold &&
        this.lastKnownY <= elementVisible - elementHeight * 0.25

    // Toggle the onscreen class based on visibility
    const wasVisible = this.classList.contains(this.dataset.onscreenClass)
    this.classList.toggle(this.dataset.onscreenClass, isVisible)

    // Add class to the parent element if product-hero has data-border and is visible
    if (isVisible && this.hasAttribute('data-border')) {
      const parentHero = this.closest('.prd-Hero')
      if (parentHero) {
        parentHero.classList.add('prd-Hero-withBorder')
      }
    } else if (!isVisible) {
      // Remove the class when the element is not visible
      const parentHero = this.closest('.prd-Hero')
      if (parentHero) {
        parentHero.classList.remove('prd-Hero-withBorder')
      }
    }

    // Handle chartVisible event
    if (this.dataset.type === 'slide_chart') {
      if (isVisible && !wasVisible) {
        // Element has become visible
        document.dispatchEvent(new CustomEvent('chartVisible'))
        this.dataset.chartVisible = true
      } else if (!isVisible && wasVisible) {
        this.dataset.chartVisible = false
      }
    }
  }

  toggleScrolledPast () {
    const elementBottom =
      window.BAO.Utils.getOffsetTop(this) + this.offsetHeight
    const viewportBottom = this.lastKnownY + window.innerHeight

    // Only apply scrolledPastClass if the element is not visible on screen
    const isOnScreen = this.classList.contains(this.dataset.onscreenClass)

    if (this.dataset.type === 'slide_intro') {
      // Toggle scrolledPastClass on page scroll
      this.classList.toggle(
        this.dataset.scrolledPastClass,
        this.lastKnownY > 0,
      )
    } else {
      // Toggle scrolledPastClass only when the element is fully scrolled past
      this.classList.toggle(
        this.dataset.scrolledPastClass,
        elementBottom <= viewportBottom && !isOnScreen,
      )
    }
  }

  toggleExtraContent () {
    const elementTop = window.BAO.Utils.getOffsetTop(this)
    const elementHeight = this.offsetHeight
    const scrollPosition = this.lastKnownY + window.innerHeight

    const galleryItemsShown = window.BAO.MediaBreakpoints.isLg
      ? 6
      : window.BAO.MediaBreakpoints.isMd
        ? 5
        : 4

    const oneThirdScrolled = elementTop + elementHeight * 0.33333

    const isOneThirdScrolled = scrollPosition >= oneThirdScrolled
    this.classList.toggle(this.dataset.extraClass, isOneThirdScrolled)

    if (!this?.externalEls['gallery-item']?.exists) return

    if (isOneThirdScrolled) {
      const scrollPastHalf = scrollPosition - oneThirdScrolled

      const itemScrollIncrement = (elementHeight * 0.66667) / galleryItemsShown

      const activeIndex = Math.min(
        Math.floor(scrollPastHalf / itemScrollIncrement),
        galleryItemsShown - 1,
      )

      this.externalEls['gallery-item'].elements.forEach((el, index) => {
        if (index === activeIndex) {
          el.classList.add('prd-Media_Slide-active')
        } else {
          el.classList.remove('prd-Media_Slide-active')
        }
      })
    } else {
      this.externalEls['gallery-item'].elements.forEach((el) => {
        el.classList.remove('prd-Media_Slide-active')
      })
    }
  }

  toggleExtraChartContent () {
    const elementTop = window.BAO.Utils.getOffsetTop(this)
    const elementHeight = this.offsetHeight
    const scrollPosition = this.lastKnownY + window.innerHeight

    // Calculate the point at which 66.667% of the element has been scrolled
    const twoThirdsScrolled = elementTop + elementHeight * 0.66667

    const isTwoThirdsScrolled = scrollPosition >= twoThirdsScrolled

    this.classList.toggle(this.dataset.extraClass, isTwoThirdsScrolled)
  }
}

if (!customElements.get('product-hero')) {
  customElements.define('product-hero', ProductHero)
}
